<template>
    <div>
        <JsonLd :json="jsonld" />
        <main id="special211101">
            <!-- 特集Specialコンテンツここから-->

            <!-- KV Section ここから -->
            <section id="kv" class="kv">
                <video playsinline autoplay muted loop>
                    <source src="../../../assets/luxury_travel/luxury_travel03/video/bg_main.mp4" type="video/mp4">
                </video>
                <div id="kv__black"></div><!-- kv__black -->
            </section><!-- kv -->

            <div class="kv__titleArea">
                <p class="kv__title--sub fadeIn">Luxury Travel</p>
                <h2 class="kv__title fadeIn" id="kv__title">Where Land Meets Sea,<br class="spNone"> Discover the Heritage of <br><i>Ama</i> Divers</h2>
                <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel03/01special')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel03/svg/play_icon.svg" alt="">Play video</p>
            </div><!-- kv__titleArea -->


            <!-- Lead Section ここから -->
            <section id="lead" class="lead">
                <div class="lead__largeImage">
                    <img src="../../../assets/luxury_travel/luxury_travel03/large_dammy.png" alt="">
                </div><!-- lead__largeImage -->


                <div class="lead__des_wrapper">
                    <p class="lead__des fadeIn">Hidden on the fringes of the Kii peninsula, the Ise-Shima area is riven with coastal bays and inlets, intrusions of the Pacific into the land. The blue waters of Ago Bay aren’t just a scenic backdrop, though; they are home to some of Japan’s most delicious seafood, such as the spiny <i>Ise ebi</i> lobster.</p>
                </div><!-- lead__des_wrapper -->

                <div class="leadPhotosArea1">
                    <img class="lead__photos01 fadeIn" src="../../../assets/luxury_travel/luxury_travel03/photos01.jpg" alt="">
                    <img class="lead__photos02 fadeIn" src="../../../assets/luxury_travel/luxury_travel03/photos02.jpg" alt="">
                </div><!-- leadPhotosArea1 -->


                <div class="lead__des_wrapper2">
                    <p class="lead__des2 fadeIn">Experience the centuries-old tradition of the <i>ama</i> divers, fearless women who venture into the ocean's depths to harvest the region’s bountiful shellfish and seaweed. </p>
                </div><!-- lead__des_wrapper2 -->

                <div class="leadPhotosArea2">
                    <img class="lead__photos03 fadeIn" src="../../../assets/luxury_travel/luxury_travel03/photos03.jpg" alt="">
                    <img class="lead__photos04 fadeIn" src="../../../assets/luxury_travel/luxury_travel03/photos04.jpg" alt="">
                </div><!-- leadPhotosArea2 -->

                <div class="lead__des_wrapper3">
                    <p class="lead__des3 fadeIn">Though mountainous and remote, this rugged coastline can be visited in comfort, however, as Ise-Shima boasts some of the most luxurious and secluded resorts in Japan.</p>
                </div><!-- lead__des_wrapper3 -->


            </section><!-- lead -->



            <!-- Heritage Section ここから -->
            <section class="heritage" id="heritage">

                <div class="heritage__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel03/video/bg_heritage.mp4" type="video/mp4">
                    </video>
                    <div id="heritage__largeImage__black"></div><!-- heritage__largeImage__black -->
                </div><!-- heritage__largeImage -->


                <div class="heritage_titleArea">
                    <h1 class="heritage_title fadeIn" id="heritage_title">The Unique Culture <br>of Female <br>Ama Divers</h1>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel03/02heritage')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel03/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- heritage_titleArea -->
            </section><!-- heritage -->


            <section class="heritage_horizon">
                <div class="heritage_horizon_inner">
                    <div class="japanHeritageWrapper">
                        <img src="../../../assets/luxury_travel/luxury_travel03/svg/japan_heritage.svg" class="japanHeritage">
                    </div><!-- japanHeritageWrapper -->

                    <div class="photo_wrapper heritage__photos01">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos05.jpg" alt="" class="heritage__photos01_inner">
                    </div><!-- heritage__photos01 -->

                    <p class="heritage__des">Once found across Japan, Ise-Shima hosts many of the country’s remaining <i>ama</i> divers. The <i>ama</i> live in close harmony with nature – plunging into the inky depths without any modern diving equipment, they rely instead on their expert knowledge of the sea and weather conditions to make their dives successfully. Although there are occasional male <i>ama</i>, the vast majority of divers in this area are female.</p>

                    <div class="photo_wrapper heritage__photos02">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos06.jpg" alt="" class="heritage__photos02_inner">
                    </div><!-- heritage__photos02 -->

                    <div class="photo_wrapper heritage__photos03">
                        <img class="heritage__photos03_inner" src="../../../assets/luxury_travel/luxury_travel03/photos07.jpg" alt="">
                    </div><!-- heritage__photos03 -->

                    <p class="heritage__des2">A typical catch includes abalone shells, turban shells, and seaweed, although the <i>ama</i> are careful never to take too much and disturb the delicate marine ecosystem – a form of sustainable fishing dating back to at least the 8th century, when <i>ama</i> divers were mentioned in the <i>Man’yoshu</i> poetry compilation. Today, you can join <i>ama</i> divers underwater as they practice their  craft or sit with them in their <i>amagoya</i> huts where they rest after dives, grilling the fresh shellfish and imparting unique tales of <i>ama</i> life.</p>



                    <div class="photo_wrapper heritage__photos04">
                        <img class="heritage__photos04_inner" src="../../../assets/luxury_travel/luxury_travel03/photos08.jpg" alt="">
                    </div><!-- heritage__photos04 -->


                    <p class="heritage__des3">The observation deck atop Mount Yokoyama offers expansive views of Ago Bay and its many islands.</p>

                    <div class="heritage__photos06">
                        <img class="heritage__photos06_inner" src="../../../assets/luxury_travel/luxury_travel03/photos09.jpg" alt="">
                    </div><!-- heritage__photos06 -->




                </div><!-- heritage_horizon_inner -->
            </section><!-- heritage_horizon -->


            <!-- Accommodation Section ここから -->
            <section class="accommodation" id="accommodation">

                <div class="accommodation__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel03/video/bg_accommodation.mp4" type="video/mp4">
                    </video>
                    <div id="accommodation__largeImage__black"></div><!-- accommodation__largeImage__black -->
                </div><!-- accommodation__largeImage -->



                <div class="accommodation__title_wrapper">
                    <h2 class="accommodation__title fadeIn">A Secluded Haven <br>in Harmony with <br>the Landscape</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel03/03zenagi')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel03/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- accommodation__title_wrapper -->


                <img class="accommodation_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel03/svg/accommodation.svg" alt="Accommodation">


                <div class="accomodation_section01">

                    <div class="accommodation_photo01 fadeIn">
                        <img class="accommodation__photos01_inner" src="../../../assets/luxury_travel/luxury_travel03/photos10.jpg" alt="">
                        <img class="accommodation__photos02_inner" src="../../../assets/luxury_travel/luxury_travel03/photos11.jpg" alt="">
                    </div><!-- accommodation_photo01 -->

                    <div class="accommodation__des_wrapper">
                        <p class="accommodation__des fadeIn">Amanemu, an Aman resort, mingles privacy with luxury, tucked away in the depths of the countryside of the Ago Bay coast. The architectural inspiration of the complex is the nearby Grand Shrine at Ise.</p>
                    </div><!-- accommodation__des_wrapper -->


                    <div class="accommodation_photo02 fadeIn">
                        <img class="accommodation__photos03_inner" src="../../../assets/luxury_travel/luxury_travel03/photos12.jpg" alt="">
                        <img class="accommodation__photos04_inner" src="../../../assets/luxury_travel/luxury_travel03/photos13.jpg" alt="">
                    </div><!-- accommodation_photo02 -->

                    <div class="accommodation_des02_wrapper">
                        <p class="accommodation_des02 fadeIn">The interiors combine the comfort of a modern hotel with the refined aesthetics of Japan; sliding doors and wood panelling give the rooms a touch of soft, golden light, while the exterior fittings and verandas offset this brightness with their dark, almost-black wood. The stylish dining room gives you a chance to feast on Ise-Shima’s fabled seafood, as well as wide views out over Ago Bay. </p>
                    </div><!-- accommodation__des02_wrapper -->

                </div><!-- accomodation_section01 -->



                <div class="accomodation_section02">

                    <div class="accommodation_photo03 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos14.jpg" alt="">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos15.jpg" alt="">
                    </div><!-- accommodation_photo03 -->

                    <div class="accommodation_des03_wrapper">
                        <p class="accommodation_des03 fadeIn">The last word in relaxation is to be had at the 2,000-sqm spa, a spacious and well-appointed compound centred around the steaming waters of the hot spring pools.</p>
                    </div><!-- accommodation__des03_wrapper -->

                </div><!-- accomodation_section02 -->

            </section><!-- accommodation -->


            <!-- Cuisine Section  ここから -->
            <section id="cuisine" class="cuisine">

                <div class="cuisine__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel03/video/bg_cuisine.mp4" type="video/mp4">
                    </video>
                    <div id="cuisine__largeImage__black"></div><!-- cuisine__largeImage__black -->
                </div><!-- cuisine__largeImage -->

                <img class="cuisine_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel03/svg/cuisine.svg" alt="Cuisine">

                <div class="cuisine__title_wrapper">
                    <h2 class="cuisine__title fadeIn">Gourmet Pleasures <br>from the Sea</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel03/04cuisine')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel03/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- cuisine__title_wrapper -->

                <div class="cuisine_section01">

                    <div class="cuisine__des_wrapper">
                        <p class="cuisine__des fadeIn">Facing on to both the sheltered waters of the bay and the Pacific depths, the coasts here yield a broad variety of marine delicacies. At the Amanemu resort, the airy surroundings of the dining room are a fine setting in which to enjoy one of the area’s most esteemed foods – the <i>Ise ebi</i> lobster.</p>
                    </div><!-- cuisine__des_wrapper -->

                    <div class="cuisine_photo01 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos16.jpg" alt="">
                    </div><!-- cuisine_photo01 -->

                    <div class="cuisine__des02_wrapper">
                        <p class="cuisine__des02 fadeIn">This spiky crustacean, with its succulent white flesh, can live for decades and is associated with longevity in traditional culture. But <i>Ise ebi</i> is just one of the many delicious seafoods waiting to be sampled. Japan’s renowned sashimi is also available, with squid and fish such as bonito and barracuda among many others served to you fresh from the sea.</p>
                    </div><!-- cuisine__des02_wrapper -->

                    <div class="cuisine_photo02 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos17.jpg" alt="">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos18.jpg" alt="">
                    </div><!-- cuisine_photo02 -->

                </div><!-- cuisine_section01 -->

                <div class="cuisine_section02">

                    <div class="cuisine__des03_wrapper">
                        <p class="cuisine__des03 fadeIn">You can also enjoy the sea’s bounty direct from the source, with the <i>ama</i> divers in their seashore huts. The simple interior with its <i>tatami</i> mats and brick-lined brazier is the perfect setting to barbeque the freshly-caught seafood, while you can chat with the <i>ama</i> and learn the secrets of their unique trade.</p>
                    </div><!-- cuisine__des03_wrapper -->

                    <div class="cuisine_photo03 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos19.jpg" alt="">
                        <img src="../../../assets/luxury_travel/luxury_travel03/photos20.jpg" alt="">
                    </div><!-- cuisine_photo02 -->

                </div><!-- cuisine_section02 -->


            </section><!-- cuisine -->


            <!-- Experience Section ここから -->
            <section id="experience" class="experience">

                <div class="experience__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel03/video/bg_experience.mp4" type="video/mp4">
                    </video>
                    <div id="experience__largeImage__black"></div><!-- experience__largeImage__black -->
                </div><!-- experience__largeImage -->

                <div class="experience__title_wrapper">
                    <h2 class="experience__title fadeIn">Ise-Shima’s Culinary Culture <br>- Food Fit for the Gods</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel03/05experience')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel03/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- experience__title_wrapper -->



                <!-- Experience Horizon ここから -->
                <section class="experience_horizon">
                    <div class="experience_horizon_inner">

                        <div class="experienceTagWrapper">
                            <img src="../../../assets/luxury_travel/luxury_travel03/svg/experience.svg" class="experience_tag">
                        </div><!-- experienceTagWrapper -->

                        <div class="photo_wrapper experience__photos01">
                            <img src="../../../assets/luxury_travel/luxury_travel03/photos21.jpg" alt="" class="experience__photos01_inner">
                        </div><!-- experience__photos01 -->

                        <p class="experience__des2">The sea and its produce are never far away in Ise-Shima; the area was historically known as <i>Miketsu-kuni</i>, meaning “the land of divine offerings.” In particular, bonito fish and <i>kombu</i> kelp have been held in high esteem since ancient times, and form part of a twice-daily offering of food to the gods at Ise’s Grand Shrine.</p>

                        <div class="photo_wrapper experience__photos02">
                            <img src="../../../assets/luxury_travel/luxury_travel03/photos22.jpg" alt="" class="experience__photos02_inner">
                        </div><!-- experience__photos02 -->

                        <p class="experience__des3">At a bonito curing hut you can see how the fish are arranged head-to-toe in racks and smoked over an oakwood fire. Once the month-long smoking is completed, the iron-hard fish are then fermented and finally planed into long, pinkish shavings.</p>

                        <div class="photo_wrapper experience__photos03">
                            <img src="../../../assets/luxury_travel/luxury_travel03/photos23.jpg" alt="" class="experience__photos03_inner">
                        </div><!-- experience__photos03 -->

                        <p class="experience__des4">At a <i>kombu</i> kelp shop, you can try your hand at the traditional technique of scraping the seaweed, a process it’s said to take ten years to master.</p>

                        <div class="photo_wrapper experience__photos04">
                            <img src="../../../assets/luxury_travel/luxury_travel03/photos24.jpg" alt="" class="experience__photos04_inner">
                        </div><!-- experience__photos04 -->

                        <div class="photo_wrapper experience__photos05">
                            <img src="../../../assets/luxury_travel/luxury_travel03/photos25.jpg" alt="" class="experience__photos05_inner">
                        </div><!-- experience__photos05 -->

                        <p class="experience__des5">If you’d like to stretch your legs a little, cycle along the coastline of Koushirahama beach, bounded on one side by green hills and on the other by the white sand and blue reaches of the ocean.</p>

                        <div class="photo_wrapper experience__photos06">
                            <img src="../../../assets/luxury_travel/luxury_travel03/photos26.jpg" alt="" class="experience__photos06_inner">
                        </div><!-- experience__photos06 -->


                    </div><!-- experience_horizon_inner -->
                </section><!-- experience_horizon -->

            </section><!-- experience -->


            <div class="maplinkArea">
                <a class="maplink" href="https://www.google.com/maps/d/edit?hl=ja&hl=ja&mid=1pM9UQQ39Mc9E6CxP-jku30PcOMhceo0R&ll=34.33169360961955%2C136.8767976563446&z=18" target="_blank">See on map <img src="../../../assets/luxury_travel/luxury_travel03/svg/outerlink.svg"></a>
            </div><!-- maplinkArea -->

            <Questionnaire :page-id="pageId" />
            <SeeOtherLuxury />

            <!-- 特集Specialコンテンツここまで-->
            <streaks-player ref="streaks"></streaks-player>
        </main>
    </div>
</template>

<script>
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "@/components/Systems/ApiRouter";
import SeeOtherLuxury from '../SeeOtherLuxury';
import 'video.js/dist/video-js.css';
import Questionnaire from "../Questionnaire.vue";
import JsonLd from "@/components/JsonLd/JsonLd.vue";

export default {
    name: "LuxuryTravel03",
    components: {JsonLd, Questionnaire, StreaksPlayer, SeeOtherLuxury},
    mixins: [ApiRouter],
    data: function () {
        return {
            publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
            categoryId: '09788e7d-5beb-4d3b-b644-32d3a36f4755',
            keywords: ['temple&shrine', 'historic building', 'Buddha statue', 'food culture', 'religion', 'mountain'],
            videoOptions: {
                autoplay: 'true',
                controls: false,
                preload: 'none',
                fluid: true,
                loop: true,
                muted: true,
                sources: [
                    {
                        src:
                            `${process.env.VUE_APP_VIDEO_URL}` + "/streaks/luxurytravel/luxurytravel02/bg_main.m3u8",
                    }
                ],
            },
            pageId: '3',
            jsonld: {
                "@context": "https://schema.org",
                "@type": "Article",
                "mainEntityOfPage": window.location.href,
                "headline": "Where land meets sea,discover the heritage of ama divers",
                "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                    "and other cultural assets. Find photos, videos, tourist information, and more.",
                "image": [
                    require('../../../assets/luxury_travel/index/luxury03.jpg')
                ],
                "datePublished": "2022/01/24",
                "dateModified": "2023/12/19",
                "author": [{
                    "@type": "Organization",
                    "name": "Japan National Tourism Organization",
                    "url": "https://www.japan.travel/japan-heritage/"
                }]
            }
        }
    },
    mounted: function () {
        document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
        let url = this.publicPath + 'js/luxurytravel.js';
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', url);
        document.head.appendChild(recaptchaScript);
    },
    methods: {
        openStreaksPlayer: function (id) {
            this.$refs.streaks.open(id);
        },
        goToStoryPage: function (id) {
            this.$router.push({name: 'Popular', params: {id: id, page: 'about'}});
        },
    }
}
</script>

<style src="./LuxuryTravel03.scss" lang="scss" scoped/>
